import { defineMessages } from 'react-intl';

export default defineMessages({
  arrowBackAriaLabel: {
    id: 'app.components.SecondaryPageAppBar.arrowBackAriaLabel',
    defaultMessage: 'Voltar',
  },
  searchIconAriaLabel: {
    id: 'app.components.SecondaryPageAppBar.searchIconAriaLabel',
    defaultMessage: 'Procurar',
  },
});
